// CONSTANTS are all caps.
const NS = 'GeneralSearchAutoCompleteWidget';
const CLS = 'generalSearchAutoCompleteWidget';
const WG = '.' + CLS + '-';
const CLS_ACTIVE = 'is-active';
const CLS_HIDE = 'd-none';

// Import stuff here if you need to or even better to import them dynamically
// import $ from 'jquery'
import * as Api from '../../../../global/js/api';
import _ from 'lodash';
import {utils} from 'global/js/utils';


export class GeneralSearchAutoCompleteWidget {
	constructor(el) {
		this.el = el;
		this.$el = $(el);

		this.emptyMessage = this.$el.data('emptyMessage') || 'No result.';
		this.id = this.$el.data('id');
		this.$searchResult = this.$el.find(`${WG}searchResult`);
		this.$searchInp = this.$el.find(`${WG}searchInput`);
		this.$searchList = this.$el.find(`${WG}searchList`);
		this.searchPagePath = this.$el.data('search-page');

		// this is for course search block button
		this.$courseSearchBtn = this.$el.closest('.courseSearchBlock').find('.courseSearchBlock-card-body-btn');
		console.log(this.$courseSearchBtn);

		if(this.$courseSearchBtn.length >= 1 ) {
			this.initCourseSearchBtn()
		}

		this.init();
	}

	init() {
		console.log(this.searchPagePath, this.$el);

		this.handleSearchInput();
		this.handleKeyboard();
	}

	initCourseSearchBtn() {
		this.$courseSearchBtn.on('click', () => {
			console.log(12);
			this.selectSearchLink();
		});
	}


	handleSearchInput() {
		const This = this;
		This.$searchInp.on('input', _.debounce(This.search.bind(This), 500));
	}

	search(e) {
		let searchTerm = this.$searchInp.val();

		if (searchTerm.length < 3) {
			this.$searchResult.addClass(CLS_HIDE);
			return;
		}

		this.searchCall(searchTerm).then((data) => {
			if (Api.isSuccessful(data)) {
				// http://www.mocky.io/v2/5dca28d433000071003deb58
				let res = data.hits || [];
				if (res.length > 0) {
					let renderedHtml = '';
					for (let i = 0; i < res.length; i++) {
						let result = res[i];
						let newText = this.matchResult(result.query);
						let param = encodeURI(result.query);
						let url = result.url;

						renderedHtml += `
						<li class="${CLS}-searchItem">
							<a href="${url}" class="${CLS}-searchLink">${newText}</a>
						</li>`;
					}

					this.$searchList.html(renderedHtml);
				} else {
					console.log(res);
					return;
					// if api call empty results
					// let empty = `<li class="${CLS}-searchEmpty">${this.emptyMessage}</li>`;
					// this.$searchList.html(empty);
				}

				this.handleDocumentClick();
				this.$searchResult.removeClass(CLS_HIDE);
			}
		}).catch((error) => {
			console.log(NS, 'search error', error);
			// if api call error
			// this.$searchList.html(`
			// 	<li class="${CLS}-searchError text-danger">There was an error.</li>
			// `);
			// this.$searchResult.removeClass(CLS_HIDE);
		});
	}

	searchCall(searchTerm) {
		if (!searchTerm || searchTerm == '') return;

		const $wg = $(this.$el);
		let endpoint = $wg.data('searchEndpoint');
		return Api.getApi(endpoint + '?prefix=' + encodeURIComponent(searchTerm) + '&size=5' + `&id=${this.id}`);
	}

	// match result with search term
	matchResult(text) {
		let searchTerm = this.$searchInp.val();
		let matcher = new RegExp(searchTerm, 'gi');

		return _.replace(text, matcher, (term) => {
			return `<span class="${CLS}-searchMatched">${term}</span>`;
		});
	}

	selectSearchLink() {
		let $activeItem = this.$searchList.find(`${WG}searchItem.${CLS_ACTIVE}`);
		let url = '';

		console.log('hello...', $activeItem);

		if($activeItem.length === 0) {
			let $firstItem = this.$searchList.find(`${WG}searchItem:first-child`);
			if($firstItem.length === 0) {
				let keyword = this.$el.find('.generalSearchAutoCompleteWidget-searchInput').val();
				url = `${this.searchPagePath}?keyword=${keyword}`;
				console.log(url);
				window.location = url;
				return;
			}
			url = $firstItem.find(`${WG}searchLink`).prop('href');
		} else {
			url = $activeItem.find(`${WG}searchLink`).prop('href');
		}

		console.log(url);
		window.location = url;
	}

	handleKeyboard() {
		this.$searchInp.on('keyup', (e) => {
			// console.log(e.key);
			switch(e.key) {
				case 'Escape':
					this.closeSearch();
					break;

				case 'Enter':
					this.selectSearchLink();
					break;

				case 'ArrowUp':
					this.navigateSearch(false);
					break;

				case 'ArrowDown':
					this.navigateSearch(true);
					break;

				default:
					break;
			}
		});
	}

	navigateSearch(isDown) {
		let $items = this.$searchList.find(`${WG}searchItem`);
		if($items.length === 0) return;

		let $activeItem = this.$searchList.find(`${WG}searchItem.${CLS_ACTIVE}`);
		let $firstItem = this.$searchList.find(`${WG}searchItem:first-child`);
		let $lastItem = this.$searchList.find(`${WG}searchItem:last-child`);

		// check if there is active item
		if($activeItem.length === 0) {
			isDown ? $firstItem.addClass(CLS_ACTIVE) : $lastItem.addClass(CLS_ACTIVE);
		} else {
			$activeItem.removeClass(CLS_ACTIVE);

			if(isDown) {
				let $nextItem = $activeItem.next();
				$nextItem.length === 0 ? $firstItem.addClass(CLS_ACTIVE) : $nextItem.addClass(CLS_ACTIVE);
			} else {
				let $prevItem = $activeItem.prev();
				$prevItem.length === 0 ? $lastItem.addClass(CLS_ACTIVE) : $prevItem.addClass(CLS_ACTIVE);
			}
		}
	}

	closeSearch() {
		let timeout = 0;
		this.$searchResult.addClass(CLS_HIDE);

		if (this.$el.hasClass(`${CLS}--siteHeader`)) {
			let $siteHeader = this.$el.closest('.intranetSiteHeader');
			if($siteHeader.length) {
				$siteHeader.removeClass('is-searchActive');
				timeout = 300;
			}
		}

		// timeout to wait for animation complete
		setTimeout(() => {
			this.$searchInp.val('');
			this.$searchList.html('');
		}, timeout);
	}

	handleDocumentClick() {
		utils.docClick(() => {
			this.closeSearch();
		}, null, [CLS]);
	}

	// Add more functions like on above here
}
